
const digest = 'cc492ff4e34cab999f4f839de9d96a29c302361187f5836337ddc103f91eeeb0';
const classes = {"wrapper":"_wrapper_1ai2p_1","countDownBadge":"_countDownBadge_1ai2p_10"};
const css = `._wrapper_1ai2p_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 500;
  gap: 10px;
  color: #9ea0a5;
  font-size: 12px;
}
._wrapper_1ai2p_1 ._countDownBadge_1ai2p_10 {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  padding: 2px 5px;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  